









import Vue from 'vue';
import { openModal } from 'mycorems-app-shared';
import isGranted from '@/auth/isGranted';
import { PricePlan } from '@/types';
import AddPricePlanModal from './AddPricePlanModal.vue';

export default Vue.extend({
  methods: {
    openModal(): void {
      openModal(AddPricePlanModal, {})
        .onOk((pricePlan: PricePlan) => {
          this.$emit('added', pricePlan);
        });
    },
    isGranted,
  },
});
